/* ==========================================================================
   SP-FREMDWARE — Konfigurator „Eigene Textilien besticken“ (sections/sp-fremdware.liquid)
   Schritte: 1 Textilien (Mehrfachauswahl, Menge am Textil) → 2 Farbe je Textil (nur Vorschau)
             → 3 Stickpositionen + Logo (gleich für alle oder je Textil) → 4 Anlieferung
   Preis: je Textil Summe der Positionen × Menge; Staffelrabatt auf die Gesamtsumme.
   Warenkorb: je Textil und Position eine Zeile (Variante aus dem Block-Produkt, Menge = Teile) per /cart/add.js.
   Fehlt einer Position das Produkt, wird die Auswahl als Anfrage vorausgefüllt.
   ========================================================================== */
(function () {
  'use strict';

  var TEX = [
    { id: 'polo', name: 'Poloshirt' },
    { id: 'tshirt', name: 'T-Shirt' },
    { id: 'trikot', name: 'Trikot' },
    { id: 'hoodie', name: 'Hoodie & Sweat' },
    { id: 'jacke', name: 'Jacke & Softshell' },
    { id: 'weste', name: 'Weste' }
  ];
  // Positionen, die es an einem Textil nicht gibt (Weste: keine Ärmel)
  var NOPOS = { weste: { armL: 1, armR: 1 } };
  var COL = [
    { id: 'weiss', name: 'Weiß', hex: '#FFFFFF', dark: false },
    { id: 'gelb', name: 'Gelb', hex: '#F3C623', dark: false },
    { id: 'rot', name: 'Rot', hex: '#C8322F', dark: true },
    { id: 'gruen', name: 'Grün', hex: '#2E7D4F', dark: true },
    { id: 'blau', name: 'Blau', hex: '#24477F', dark: true },
    { id: 'schwarz', name: 'Schwarz', hex: '#1C1C1C', dark: true }
  ];
  // Lage der Stickfelder im 560er-Raster der Vorschau; pxcm = Pixel je cm, xl/yl = Lage bei Langarm
  var GEO = {
    brustL: { side: 'front', x: 312, y: 168, w: 70, h: 70, pxcm: 4.9 },
    brustR: { side: 'front', x: 178, y: 168, w: 70, h: 70, pxcm: 4.9 },
    armL: { side: 'front', x: 432, y: 146, w: 48, h: 48, pxcm: 4.4, xl: 418, yl: 180 },
    armR: { side: 'front', x: 80, y: 146, w: 48, h: 48, pxcm: 4.4, xl: 94, yl: 180 },
    nacken: { side: 'back', x: 245, y: 110, w: 70, h: 34, pxcm: 4.9 },
    ruecken: { side: 'back', x: 158, y: 164, w: 244, h: 124, pxcm: 4.9 }
  };
  var IMG = /\.(png|jpe?g)$/i, OKFILE = /\.(pdf|png|jpe?g|ai)$/i, MAXBYTES = 20 * 1024 * 1024;
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>';

  function eur(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function eur0(c) { return (c / 100).toLocaleString('de-DE') + ' €'; }
  function by(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return list[0]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function genId() { return 'fw' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function mobile() { return window.matchMedia('(max-width: 849px)').matches; }
  function copy(o) { var n = {}; Object.keys(o).forEach(function (k) { n[k] = o[k]; }); return n; }

  function silhouette(tex, back) {
    var neck = back ? 'C340,96 312,100 280,100 C248,100 220,96 206,86' : 'C340,110 312,122 280,122 C248,122 220,110 206,86';
    var long = tex === 'hoodie' || tex === 'jacke';
    if (tex === 'weste') {
      return {
        body: 'M206,86 L168,98 C160,140 172,188 150,214 L156,470 Q280,482 404,470 L410,214 C388,188 400,140 392,98 L354,86 ' + neck + ' Z',
        detail: back ? '' : 'M280,122 L280,476 M244,300 L262,300 M298,300 L316,300',
        long: false
      };
    }
    var body = long
      ? 'M206,86 L150,104 L112,140 L72,330 L114,342 L150,214 L154,470 Q280,482 406,470 L410,214 L446,342 L488,330 L448,140 L410,104 L354,86 ' + neck + ' Z'
      : 'M206,86 L150,104 L70,160 L104,236 L152,214 L156,470 Q280,482 404,470 L408,214 L456,236 L490,160 L410,104 L354,86 ' + neck + ' Z';
    if (tex === 'hoodie') body = (back ? 'M204,92 C188,20 372,20 356,92 C330,112 230,112 204,92 Z ' : 'M212,94 C196,30 364,30 348,94 C330,116 230,116 212,94 Z ') + body;
    var d = '';
    if (!back && tex === 'polo') d = 'M228,94 L280,138 L332,94 M280,138 L280,204 M276,158 L284,158 M276,182 L284,182';
    if (!back && tex === 'hoodie') d = 'M212,92 C196,30 364,30 348,92 M262,122 L260,188 M298,122 L300,188 M200,356 L360,356 L382,446 L178,446 Z';
    if (back && tex === 'hoodie') d = 'M208,90 C196,24 364,24 352,90 C330,110 230,110 208,90';
    if (!back && tex === 'jacke') d = 'M280,122 L280,476 M212,92 L222,64 L280,80 L338,64 L348,92';
    if (!back && tex === 'tshirt') d = 'M216,96 C238,126 322,126 344,96';
    if (tex === 'trikot') d = (back ? '' : 'M222,92 L280,150 L338,92 ') + 'M210,90 L154,210 M350,90 L406,210';
    return { body: body, detail: d, long: long };
  }

  function init(root) {
    if (root.dataset.fwReady) return;
    root.dataset.fwReady = '1';
    var data;
    try { data = JSON.parse(root.querySelector('[data-fw-data]').textContent); } catch (e) { console.error('[spfw] data', e); return; }
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var POS = (data.positions || []).filter(function (p) { return GEO[p.key]; }).map(function (p) { return Object.assign({}, GEO[p.key], p); });
    var TIERS = String(data.tiers || '').split(',').map(function (t) {
      var a = t.split(':'); return { cents: Math.round(parseFloat(String(a[0]).replace(',', '.')) * 100), pct: parseFloat(String(a[1]).replace(',', '.')) };
    }).filter(function (t) { return t.cents > 0 && t.pct > 0; }).sort(function (a, b) { return a.cents - b.cents; });
    var QMIN = Math.max(1, data.qtyMin || 1), QSTEP = Math.max(1, data.qtyStep || 1), MINO = data.minOrder || 0;
    var QDEF = Math.max(QMIN, data.qty || 25);
    var TECH = { stick: 'Stick', druck: 'Digitaldruck' };

    // Zustand: je Textilart ein Eintrag; same = gleiche Stickpositionen für alle gewählten Textilien (st.sel/st.widths)
    var st = { items: {}, same: true, sel: {}, widths: {}, tech: {}, active: 'polo', side: 'front', logo: null, delivery: 'bring', company: '', dnote: '', open: 1, busy: false };
    TEX.forEach(function (t) { st.items[t.id] = { id: t.id, on: t.id === 'polo', qty: QDEF, color: 'blau', sel: {}, widths: {}, tech: {} }; });
    if (POS[0]) st.sel[POS[0].key] = true;

    function onItems() { return TEX.map(function (t) { return st.items[t.id]; }).filter(function (it) { return it.on; }); }
    function target(it) { return st.same ? st : (it || st.items[st.active]); }
    function selOf(it) { return target(it).sel; }
    // Technik je Position: stick (Standard) oder druck, wenn der Block Digitaldruck erlaubt
    function techOf(p, it) { return p.print && target(it).tech[p.key] === 'druck' ? 'druck' : 'stick'; }
    function isDruck(p, it) { return techOf(p, it) === 'druck'; }
    function maxOf(p, it) { return isDruck(p, it) ? p.pmax : p.max; }
    function priceOf(p, it) { return isDruck(p, it) ? p.pprice : p.price; }
    function variantOf(p, it) { return isDruck(p, it) ? p.pvariant : p.variant; }
    function widthOf(p, it) { var w = target(it).widths[p.key], m = maxOf(p, it); return Math.min(m, w != null ? w : (p.key === 'ruecken' ? Math.min(m, 24) : Math.min(m, 8))); }
    function allowed(p, it) { return !(NOPOS[it.id] && NOPOS[it.id][p.key]); }
    function chosenOf(it) { var s = selOf(it); return POS.filter(function (p) { return s[p.key] && allowed(p, it); }); }
    // Kachel gesperrt, wenn kein betroffenes Textil die Position hat
    function blocked(p) { return st.same ? onItems().every(function (it) { return !allowed(p, it); }) : !allowed(p, st.items[st.active]); }
    function texName(it) { return by(TEX, it.id).name; }
    function posText(it) { return chosenOf(it).map(function (p) { return p.name + ' ' + widthOf(p, it) + ' cm' + (isDruck(p, it) ? ' Druck' : ''); }).join(', '); }
    function copyT(o) { return { sel: copy(o.sel), widths: copy(o.widths), tech: copy(o.tech) }; }
    function assignT(dst, o) { dst.sel = o.sel; dst.widths = o.widths; dst.tech = o.tech; }
    function deliveryName() { var b = $('[data-fw-delivery="' + st.delivery + '"]'); return b ? b.getAttribute('data-name') : st.delivery; }
    function ensureActive() { var on = onItems(); if (!st.items[st.active].on && on[0]) st.active = on[0].id; }
    function firstOther(id) { var o = onItems().filter(function (x) { return x.id !== id; })[0]; return o ? o.id : id; }

    function calc() {
      var lines = onItems().map(function (it) {
        var ch = chosenOf(it), per = ch.reduce(function (s, p) { return s + priceOf(p, it); }, 0);
        return { it: it, ch: ch, per: per, sub: per * it.qty };
      });
      var sub = lines.reduce(function (s, l) { return s + l.sub; }, 0), cur = null, next = null;
      var pieces = lines.reduce(function (s, l) { return s + l.it.qty; }, 0);
      TIERS.forEach(function (t) { if (sub >= t.cents) cur = t; else if (!next) next = t; });
      var disc = cur ? Math.round(sub * cur.pct / 100) : 0;
      var any = lines.length > 0 && lines.every(function (l) { return l.ch.length; });
      // Warenkorb nur, wenn jede gewählte Position eine Variante für ihre Technik hat; sonst Anfrage
      var ready = POS.length > 0 && (any
        ? lines.every(function (l) { return l.ch.every(function (p) { return !!variantOf(p, l.it); }); })
        : POS.every(function (p) { return !!p.variant; }));
      var druck = lines.some(function (l) { return l.ch.some(function (p) { return isDruck(p, l.it); }); });
      var stick = lines.some(function (l) { return l.ch.some(function (p) { return !isDruck(p, l.it); }); });
      return { lines: lines, any: any, ready: ready, druck: druck, stick: stick, pieces: pieces, sub: sub, cur: cur, next: next, disc: disc, total: sub - disc };
    }

    /* ---------- Vorschau: zeigt das aktive Textil ---------- */
    function renderPreview() {
      ensureActive();
      var it = st.items[st.active], col = by(COL, it.color), back = st.side === 'back';
      var sh = silhouette(it.id, back);
      var outline = col.id === 'schwarz' ? '#3A3F44' : '#8A928E';
      var body = $('[data-fw-body]'), det = $('[data-fw-detail]');
      body.setAttribute('d', sh.body); body.setAttribute('fill', col.hex); body.setAttribute('stroke', outline);
      det.setAttribute('d', sh.detail); det.setAttribute('stroke', outline);
      $('[data-fw-ptitle]').textContent = texName(it) + ' · ' + col.name + ' · ' + (back ? 'Rückseite' : 'Vorderseite');
      $$('[data-fw-side]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fw-side') === st.side ? 'true' : 'false'); });
      var pv = $('[data-fw-pview]'), on = onItems();
      if (pv) {
        pv.hidden = on.length < 2;
        pv.innerHTML = on.length < 2 ? '' : on.map(function (o) {
          return '<button type="button" class="b" data-fw-show="' + o.id + '" aria-pressed="' + (o.id === st.active ? 'true' : 'false') + '">' + esc(texName(o)) + '</button>';
        }).join('');
      }

      var box = $('[data-fw-areas]'), line = col.dark ? '#FFFFFF' : '#111111', n = 0, sel = selOf(it);
      box.innerHTML = '';
      POS.forEach(function (p) {
        if (!sel[p.key] || p.side !== st.side || !allowed(p, it)) return;
        n++;
        var g = (sh.long && p.xl) ? Object.assign({}, p, { x: p.xl, y: p.yl }) : p;
        var cm = widthOf(p, it);
        var lw = Math.min(g.w - 8, cm * g.pxcm), lh = Math.min(g.h - 8, lw * 0.55);
        var pc = function (v) { return (v / 560 * 100).toFixed(3) + '%'; };
        var a = document.createElement('div');
        a.className = 'fw-area';
        a.style.cssText = 'left:' + pc(g.x) + ';top:' + pc(g.y) + ';width:' + pc(g.w) + ';height:' + pc(g.h) + ';--c:' + line;
        var lg = document.createElement('div'), L = st.logo;
        if (L && L.preview) {
          lg.className = 'fw-logo';
          lh = Math.min(g.h - 8, lw * (L.ratio || 0.55));
          lg.innerHTML = '<img src="' + esc(L.preview) + '" alt="">';
        } else if (L) {
          lg.className = 'fw-logo fw-logo--solid';
          lg.style.setProperty('--c', line);
          lg.innerHTML = '<span class="l" style="color:' + (col.dark ? '#111111' : '#FFFFFF') + '">Dein Logo</span>';
        } else {
          lg.className = 'fw-logo fw-logo--ph';
          lg.innerHTML = '<span class="l" style="color:#111111">Logo</span>';
        }
        lg.style.width = (lw / g.w * 100).toFixed(1) + '%';
        lg.style.height = (lh / g.h * 100).toFixed(1) + '%';
        a.appendChild(lg);
        var tag = document.createElement('span');
        tag.className = 'fw-tag l tn'; tag.textContent = (isDruck(p, it) ? 'Druck ' : '') + cm + ' cm';
        a.appendChild(tag);
        box.appendChild(a);
      });
      $('[data-fw-empty]').hidden = n > 0;
    }

    /* ---------- Schritt 1: Textilien mit Menge ---------- */
    function renderPicks() {
      var box = $('[data-fw-picks]');
      box.innerHTML = '';
      TEX.forEach(function (t) {
        var it = st.items[t.id];
        var row = document.createElement('div');
        row.className = 'fw-pick' + (it.on ? ' is-on' : '');
        var main = '<button type="button" class="fw-pick__main" data-fw-pick="' + t.id + '" aria-pressed="' + (it.on ? 'true' : 'false') + '">' +
          '<span class="fw-box">' + (it.on ? CHECK : '') + '</span><span class="b">' + esc(t.name) + '</span></button>';
        var right = it.on
          ? '<div class="fw-pick__qty"><button type="button" class="fw-sq fw-sq--s b" data-fw-iq="-1" data-t="' + t.id + '" aria-label="' + esc(t.name) + ': weniger">–</button>' +
            '<label class="fw-pick__val s tn"><input type="text" inputmode="numeric" autocomplete="off" data-fw-iqin="' + t.id + '" value="' + it.qty + '" aria-label="Anzahl ' + esc(t.name) + '"><span>Stk.</span></label>' +
            '<button type="button" class="fw-sq fw-sq--s b" data-fw-iq="1" data-t="' + t.id + '" aria-label="' + esc(t.name) + ': mehr">+</button></div>'
          : '<button type="button" class="fw-pick__add b mut" data-fw-pick="' + t.id + '" tabindex="-1">Hinzufügen</button>';
        row.innerHTML = main + right;
        box.appendChild(row);
      });
    }

    /* ---------- Schritt 2: Farbe je Textil ---------- */
    function renderColors() {
      var box = $('[data-fw-colorrows]'), on = onItems();
      box.innerHTML = '';
      on.forEach(function (it) {
        var g = document.createElement('div'); g.className = 'fw-group';
        var sw = COL.map(function (c) {
          return '<button type="button" class="fw-sw" style="background:' + c.hex + '" data-fw-color="' + c.id + '" data-t="' + it.id + '" aria-label="' + esc(texName(it)) + ': ' + c.name + '" title="' + c.name + '" aria-pressed="' + (c.id === it.color ? 'true' : 'false') + '"></button>';
        }).join('');
        g.innerHTML = (on.length > 1 ? '<p class="l mut">' + esc(texName(it)) + ' · ' + by(COL, it.color).name + '</p>' : '') + '<div class="fw-sws">' + sw + '</div>';
        box.appendChild(g);
      });
      var m = $('[data-fw-colorname]'); if (m) m.textContent = on.length === 1 ? by(COL, on[0].color).name : '';
    }

    /* ---------- Schritt 3: Positionen, Breiten, Logo ---------- */
    function renderPositions() {
      var on = onItems(), multi = on.length > 1;
      var tg = $('[data-fw-same]');
      tg.hidden = !multi;
      tg.setAttribute('aria-checked', st.same ? 'true' : 'false');
      var seg = $('[data-fw-for]');
      seg.hidden = !multi || st.same;
      seg.innerHTML = (!multi || st.same) ? '' : on.map(function (it) {
        return '<button type="button" class="b" data-fw-for-t="' + it.id + '" aria-pressed="' + (it.id === st.active ? 'true' : 'false') + '">' + esc(texName(it)) + '</button>';
      }).join('');

      var cur = st.items[st.active], sel = selOf(cur);
      var pos = $('[data-fw-pos]');
      pos.innerHTML = '';
      [['front', 'Vorne'], ['back', 'Hinten']].forEach(function (sd) {
        var items = POS.filter(function (p) { return p.side === sd[0]; });
        if (!items.length) return;
        var g = document.createElement('div'); g.className = 'fw-group';
        g.innerHTML = '<p class="l mut">' + sd[1] + '</p>';
        var t = document.createElement('div'); t.className = 'fw-tiles';
        items.forEach(function (p) {
          var off = blocked(p), isOn = !!sel[p.key] && !off;
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'fw-tile fw-tile--left';
          b.setAttribute('data-fw-p', p.key); b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
          if (off) { b.disabled = true; b.title = 'Bei Westen nicht möglich'; }
          var sub = isOn ? TECH[techOf(p, cur)] : (p.print ? 'Stick · Druck' : 'bis ' + p.max + ' cm · ' + eur(p.price));
          b.innerHTML = '<span class="b">' + esc(p.name) + '</span><span class="l' + (isOn ? '' : ' mut') + ' tn">' + sub + '</span>';
          t.appendChild(b);
        });
        g.appendChild(t); pos.appendChild(g);
      });

      // Je gewählter Position: Technik (Stick | Digitaldruck), Breite, Preis
      var wb = $('[data-fw-widths]'), ch = chosenOf(cur), anyPrint = POS.some(function (p) { return p.print; });
      var poslab = $('[data-fw-poslabel]'); if (poslab) poslab.hidden = !anyPrint;
      wb.innerHTML = '';
      if (ch.length) {
        var per = ch.reduce(function (s, p) { return s + priceOf(p, cur); }, 0);
        var hd = document.createElement('div'); hd.className = 'fw-prows__h';
        hd.innerHTML = '<p class="l mut">' + (anyPrint ? '2 · Technik und Größe je Position' : 'Größe je Position') + '</p>' +
          '<span class="b mut tn">' + (st.same || onItems().length < 2 ? 'Je Teil' : esc(texName(cur))) + ': ' + eur(per) + ' / Stk.</span>';
        wb.appendChild(hd);
      }
      ch.forEach(function (p) {
        var cm = widthOf(p, cur), mx = maxOf(p, cur), dr = isDruck(p, cur);
        var r = document.createElement('div'); r.className = 'fw-prow';
        var seg = p.print
          ? '<div class="fw-tech" role="group" aria-label="Technik für ' + esc(p.name) + '">' +
            '<button type="button" class="b" data-fw-tech="stick" data-k="' + p.key + '" aria-pressed="' + (dr ? 'false' : 'true') + '">Stick</button>' +
            '<button type="button" class="b" data-fw-tech="druck" data-k="' + p.key + '" aria-pressed="' + (dr ? 'true' : 'false') + '">Digitaldruck</button></div>'
          : '';
        r.innerHTML = '<div class="fw-prow__h"><span class="s fw-prow__n">' + esc(p.name) + '</span>' +
          '<span class="b tn">' + eur(priceOf(p, cur)) + '<span class="mut"> / Stk.</span></span>' +
          '<button type="button" class="fw-prow__x" data-fw-p="' + p.key + '" aria-label="' + esc(p.name) + ' entfernen"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
          seg + '<p class="l mut">Breite</p>' +
          '<div class="fw-step"><button type="button" class="fw-sq fw-sq--s" data-fw-w="-1" data-k="' + p.key + '" aria-label="' + esc(p.name) + ' schmaler"' + (cm <= 3 ? ' disabled' : '') + '>–</button>' +
          '<span class="s tn fw-wrow__v">' + cm + ' cm</span>' +
          '<button type="button" class="fw-sq fw-sq--s" data-fw-w="1" data-k="' + p.key + '" aria-label="' + esc(p.name) + ' breiter"' + (cm >= mx ? ' disabled' : '') + '>+</button>' +
          '<span class="b mut fw-step__max">bis ' + mx + ' cm</span></div>';
        wb.appendChild(r);
      });
      var th = $('[data-fw-techhint]'); if (th) th.hidden = !ch.some(function (p) { return p.print; });

      var fr = $('[data-fw-filerow]'), L = st.logo;
      fr.hidden = !L;
      $('[data-fw-drop]').hidden = !!L;
      if (L) {
        fr.classList.toggle('is-error', L.status === 'error');
        $('[data-fw-filename]').textContent = L.name;
        $('[data-fw-filestate]').textContent = L.status === 'done' ? 'Hochgeladen' : (L.status === 'error' ? L.error : (L.status === 'local' ? 'Ausgewählt' : 'Lädt hoch …'));
      }
    }

    /* ---------- Status der Schritte (mobil: Akkordeon) ---------- */
    function renderStatus() {
      $$('[data-fw-delivery]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fw-delivery') === st.delivery ? 'true' : 'false'); });
      $('[data-fw-dealer]').hidden = st.delivery !== 'dealer';
      var on = onItems(), L = st.logo;
      var allPos = on.length > 0 && on.every(function (it) { return chosenOf(it).length; });
      var done = {
        1: on.length > 0,
        2: on.length > 0,
        3: allPos && !!L && L.status !== 'error' && L.status !== 'uploading',
        4: st.delivery !== 'dealer' || !!st.company.trim()
      };
      var val = {
        1: on.map(function (it) { return it.qty + ' × ' + texName(it); }).join(', ') || 'Noch nichts gewählt',
        2: on.map(function (it) { return (on.length > 1 ? texName(it) + ' ' : '') + by(COL, it.color).name; }).join(' · '),
        3: allPos ? (st.same || on.length < 2 ? posText(on[0]) : on.map(function (it) { return texName(it) + ': ' + posText(it); }).join(' · ')) : 'Noch keine Position',
        4: deliveryName()
      };
      $$('[data-fw-step]').forEach(function (c) {
        var i = +c.getAttribute('data-fw-step');
        c.classList.toggle('is-done', !!done[i]);
        c.classList.toggle('is-open', st.open === i);
        var v = c.querySelector('[data-fw-val]'); if (v) v.textContent = val[i];
      });
    }

    /* ---------- Zusammenfassung ---------- */
    function renderSummary() {
      var r = calc();
      var lp = $('[data-fw-lines]');
      lp.innerHTML = '';
      r.lines.forEach(function (l, i) {
        var h = document.createElement('div'); h.className = 'fw-line' + (i ? ' fw-line--sep' : '');
        h.innerHTML = '<span class="b">' + l.it.qty + ' × ' + esc(texName(l.it)) + ', eigene Ware</span><span class="b">' + eur(l.sub) + '</span>';
        lp.appendChild(h);
        if (!l.ch.length) { var e = document.createElement('div'); e.className = 'fw-line'; e.innerHTML = '<span class="b k">Noch keine Position</span><span></span>'; lp.appendChild(e); }
        l.ch.forEach(function (p) {
          var d = document.createElement('div'); d.className = 'fw-line';
          d.innerHTML = '<span class="b k">' + TECH[techOf(p, l.it)] + ' ' + esc(p.name) + ', ' + widthOf(p, l.it) + ' cm</span><span class="b k">' + eur(priceOf(p, l.it)) + ' / Stk.</span>';
          lp.appendChild(d);
        });
      });

      var txt, w;
      if (!r.lines.length) { txt = 'Wähle in Schritt 1 dein Textil.'; w = 0; }
      else if (!r.any) { txt = 'Wähle für jedes Textil mindestens eine Position.'; w = 0; }
      else if (r.sub < MINO) { txt = 'Noch ' + eur(MINO - r.sub) + ' bis zum Mindestbestellwert'; w = r.sub / MINO * 100; }
      else if (r.next) { txt = 'Noch ' + eur(r.next.cents - r.sub) + ' bis ' + r.next.pct + ' % Rabatt'; w = r.sub / r.next.cents * 100; }
      else { txt = TIERS.length ? 'Höchste Rabattstufe erreicht' : ''; w = 100; }
      $('[data-fw-tiertext]').textContent = txt;
      $('[data-fw-bar]').style.width = Math.min(100, w).toFixed(1) + '%';
      var tb = $('[data-fw-tiers]');
      tb.innerHTML = '';
      TIERS.forEach(function (t) {
        var d = document.createElement('div');
        d.className = 'fw-tier' + (r.cur && r.cur.cents === t.cents ? ' is-on' : '');
        d.innerHTML = '<span class="h tn">' + t.pct + ' %</span><span class="l">ab ' + eur0(t.cents) + '</span>';
        tb.appendChild(d);
      });
      tb.hidden = !TIERS.length;

      var sf = $('[data-fw-stickfile]'); if (sf) sf.hidden = r.any && !r.stick;
      $('[data-fw-l-sub]').textContent = eur(r.sub);
      $('[data-fw-discrow]').hidden = !r.disc;
      if (r.cur) $('[data-fw-l-disclabel]').textContent = 'Staffelrabatt ' + r.cur.pct + ' %';
      $('[data-fw-l-disc]').textContent = '– ' + eur(r.disc);
      $('[data-fw-l-total]').textContent = eur(r.total);

      var main = $('.fw-sum [data-fw-add]');
      main.textContent = r.ready ? data.cartLabel : data.askLabel;
      main.classList.toggle('is-off', !r.any);
      main.setAttribute('aria-disabled', r.any ? 'false' : 'true');
      var al = $('[data-fw-ask]'); if (al) al.hidden = !r.ready;

      var one = r.lines.length === 1 ? r.lines[0] : null;
      $('[data-fw-m-meta]').textContent = one ? one.it.qty + ' Stück · ' + eur(one.per) + ' je Teil' : r.pieces + ' Teile · ' + r.lines.length + ' Textilien';
      $('[data-fw-m-total]').textContent = eur(r.total);
      $('[data-fw-m-tier]').textContent = !r.any ? 'Position wählen' : r.sub < MINO ? 'Noch ' + eur(MINO - r.sub) + ' bis Mindestbestellwert' : (r.next ? 'Noch ' + eur(r.next.cents - r.sub) + ' bis ' + r.next.pct + ' %' : (r.cur ? r.cur.pct + ' % Rabatt aktiv' : ''));
      $('[data-fw-mbtn]').textContent = r.ready ? 'Warenkorb' : 'Anfragen';
      return r;
    }

    function refresh() { ensureActive(); renderColors(); renderPositions(); renderPreview(); renderStatus(); renderSummary(); }
    function render() { ensureActive(); renderPicks(); refresh(); }

    function openStep(i, scroll) {
      st.open = i;
      renderStatus();
      if (!scroll || !mobile()) return;
      var el = i ? $('[data-fw-step="' + i + '"]') : $('[data-fw-sum]');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---------- Mengen am Textil ---------- */
    function setQty(t, n) { n = parseInt(n, 10); if (isNaN(n)) n = QMIN; st.items[t].qty = Math.min(9999, Math.max(QMIN, n)); }
    function isQtyIn(el) { return el && el.getAttribute && el.getAttribute('data-fw-iqin'); }
    root.addEventListener('input', function (e) {
      var t = isQtyIn(e.target);
      if (!t) return;
      var v = e.target.value.replace(/\D/g, '').slice(0, 4);
      if (e.target.value !== v) e.target.value = v;
      var n = parseInt(v, 10);
      if (!isNaN(n) && n >= QMIN) { st.items[t].qty = n; st.active = t; renderPreview(); renderStatus(); renderSummary(); }
    });
    root.addEventListener('focusout', function (e) {
      var t = isQtyIn(e.target);
      if (!t) return;
      setQty(t, e.target.value); e.target.value = st.items[t].qty; renderStatus(); renderSummary();
    });
    root.addEventListener('focusin', function (e) { if (isQtyIn(e.target)) setTimeout(function () { e.target.select(); }, 0); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && isQtyIn(e.target)) { e.preventDefault(); e.target.blur(); } });

    /* ---------- Logo-Upload ---------- */
    var fileIn = $('[data-fw-file]');
    function setFile(f) {
      if (!f) return;
      if (st.logo && st.logo.preview && st.logo.preview.indexOf('blob:') === 0) URL.revokeObjectURL(st.logo.preview);
      var L = { name: f.name, status: 'uploading', url: '', error: '', preview: '', ratio: 0.55 };
      st.logo = L;
      if (!OKFILE.test(f.name)) { L.status = 'error'; L.error = 'Dateityp nicht erlaubt'; refresh(); return; }
      if (f.size > MAXBYTES) { L.status = 'error'; L.error = 'Größer als 20 MB'; refresh(); return; }
      if (IMG.test(f.name) && window.URL) {
        L.preview = URL.createObjectURL(f);
        var im = new Image();
        im.onload = function () { if (im.naturalWidth) { L.ratio = im.naturalHeight / im.naturalWidth; renderPreview(); } };
        im.src = L.preview;
      }
      if (!data.upload) { L.status = 'local'; refresh(); return; }
      refresh();
      var fd = new FormData(); fd.append('file', f);
      fetch(data.upload, { method: 'POST', body: fd }).then(function (r) { return r.json(); })
        .then(function (d) { var u = d && (d.url || d.secure_url); if (u) { L.status = 'done'; L.url = u; } else { L.status = 'error'; L.error = 'Upload fehlgeschlagen'; } })
        .catch(function () { L.status = 'error'; L.error = 'Upload fehlgeschlagen'; })
        .then(function () { if (st.logo === L) refresh(); });
    }
    var drop = $('[data-fw-drop]');
    drop.addEventListener('click', function () { fileIn.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileIn.click(); } });
    fileIn.addEventListener('change', function () { setFile(fileIn.files && fileIn.files[0]); fileIn.value = ''; });
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
    drop.addEventListener('drop', function (e) { setFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });

    /* ---------- Firmenname, Hinweis ---------- */
    var comp = $('[data-fw-company]'), compErr = $('[data-fw-companyerr]');
    comp.addEventListener('input', function () {
      st.company = comp.value;
      if (st.company.trim()) { comp.classList.remove('is-error'); compErr.hidden = true; }
      renderStatus();
    });
    var dnote = $('[data-fw-dnote]');
    if (dnote) dnote.addEventListener('input', function () { st.dnote = dnote.value; });

    /* ---------- Klicks ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a, [data-fw-step]');
      if (!t || !root.contains(t)) return;
      var a;
      if ((a = t.getAttribute('data-fw-pick'))) {
        var it = st.items[a];
        if (it.on && onItems().length === 1) { msg('Mindestens ein Textil bleibt ausgewählt.', true); return; }
        it.on = !it.on;
        if (it.on) {
          if (!st.same) assignT(it, copyT(st.items[firstOther(a)]));
          st.active = a;
        }
        msg('');
        render();
        if (it.on && !mobile()) { var inp = $('[data-fw-iqin="' + a + '"]'); if (inp) inp.focus(); }
      }
      else if ((a = t.getAttribute('data-fw-iq'))) {
        var k = t.getAttribute('data-t'), cur = st.items[k].qty;
        var n = cur + (+a) * QSTEP;
        if (+a > 0 && cur % QSTEP) n = Math.ceil(cur / QSTEP) * QSTEP;
        if (+a < 0 && cur % QSTEP) n = Math.floor(cur / QSTEP) * QSTEP;
        setQty(k, n); st.active = k;
        var inp2 = $('[data-fw-iqin="' + k + '"]'); if (inp2) inp2.value = st.items[k].qty;
        renderPreview(); renderStatus(); renderSummary();
      }
      else if ((a = t.getAttribute('data-fw-color'))) { var ct = t.getAttribute('data-t'); st.items[ct].color = a; st.active = ct; refresh(); }
      else if ((a = t.getAttribute('data-fw-show'))) { st.active = a; renderPreview(); renderPositions(); }
      else if (t.hasAttribute('data-fw-same')) {
        st.same = !st.same;
        if (st.same) assignT(st, copyT(st.items[st.active]));
        else onItems().forEach(function (x) { assignT(x, copyT(st)); });
        refresh();
      }
      else if ((a = t.getAttribute('data-fw-for-t'))) { st.active = a; refresh(); }
      else if ((a = t.getAttribute('data-fw-side'))) { st.side = a; renderPreview(); }
      else if ((a = t.getAttribute('data-fw-p'))) {
        var tg = target(st.items[st.active]);
        tg.sel[a] = !tg.sel[a];
        var p = POS.filter(function (q) { return q.key === a; })[0];
        if (p && tg.sel[a]) st.side = p.side;
        refresh();
      }
      else if ((a = t.getAttribute('data-fw-w'))) {
        var key = t.getAttribute('data-k'), q = POS.filter(function (x) { return x.key === key; })[0], tw = target(st.items[st.active]);
        if (q) { tw.widths[key] = Math.max(3, Math.min(maxOf(q, st.items[st.active]), widthOf(q, st.items[st.active]) + (+a))); st.side = q.side; refresh(); }
      }
      else if ((a = t.getAttribute('data-fw-tech'))) {
        var tk = t.getAttribute('data-k'), tq = POS.filter(function (x) { return x.key === tk; })[0], tt = target(st.items[st.active]);
        if (tq) {
          tt.tech[tk] = a;
          var cw = tt.widths[tk], mx2 = maxOf(tq, st.items[st.active]);
          if (cw != null && cw > mx2) tt.widths[tk] = mx2;
          st.side = tq.side; refresh();
          var fb = $('[data-fw-tech="' + a + '"][data-k="' + tk + '"]'); if (fb) fb.focus({ preventScroll: true });
        }
      }
      else if (t.hasAttribute('data-fw-filex')) { if (st.logo && st.logo.preview) URL.revokeObjectURL(st.logo.preview); st.logo = null; refresh(); }
      else if ((a = t.getAttribute('data-fw-delivery'))) { st.delivery = a; renderStatus(); if (a === 'dealer' && !st.company) setTimeout(function () { comp.focus({ preventScroll: true }); }, 0); }
      else if ((a = t.getAttribute('data-fw-edit'))) openStep(+a, true);
      else if (t.hasAttribute('data-fw-next')) openStep(+t.getAttribute('data-fw-next'), true);
      else if (t.hasAttribute('data-fw-add')) submit();
      else if (t.hasAttribute('data-fw-ask')) prefill();
      else if (t.hasAttribute('data-fw-step') && mobile() && !t.classList.contains('is-open')) {
        var i = +t.getAttribute('data-fw-step');
        if (!t.classList.contains('is-done')) openStep(i, true);
      }
    });

    /* ---------- Anfrage vorausfüllen ---------- */
    function summaryText() {
      var s = 'Eigene Textilien veredeln:';
      onItems().forEach(function (it) {
        var ps = chosenOf(it).map(function (p) { return TECH[techOf(p, it)] + ' ' + p.name + ' ' + widthOf(p, it) + ' cm'; }).join(', ');
        s += '\n- ' + it.qty + ' × ' + texName(it) + ' (Farbe laut Vorschau: ' + by(COL, it.color).name + '): ' + (ps || 'Positionen noch offen');
      });
      s += '\nAnlieferung: ' + deliveryName() + (st.delivery === 'dealer' && st.company.trim() ? ' – Firmenname beim Händler: ' + st.company.trim() : '') + '.';
      if (st.dnote.trim()) s += '\nHinweis zur Anlieferung: ' + st.dnote.trim();
      if (st.logo && st.logo.url) s += '\nLogo: ' + st.logo.url;
      return s;
    }
    function prefill() {
      var sec = document.getElementById(data.ask);
      if (!sec) return false;
      var ta = sec.querySelector('textarea');
      if (ta && (!ta.value.trim() || ta.getAttribute('data-fw-filled') === '1')) { ta.value = summaryText(); ta.setAttribute('data-fw-filled', '1'); }
      var radios = sec.querySelectorAll('input[type="radio"][name="contact[Gewünschte Menge]"]');
      if (radios.length) {
        var lim = [50, 100, 250], idx = 0, total = calc().pieces;
        while (idx < lim.length && total > lim[idx]) idx++;
        var r = radios[Math.min(idx, radios.length - 1)]; if (r && !sec.querySelector('input[type="radio"]:checked')) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      return true;
    }

    /* ---------- Warenkorb ---------- */
    var msgEl = $('[data-fw-msg]');
    function msg(t, err, html) {
      msgEl.hidden = !t;
      msgEl.classList.toggle('is-error', !!err);
      if (html) msgEl.innerHTML = t; else msgEl.textContent = t;
    }
    function submit() {
      if (st.busy) return;
      var r = calc();
      var empty = r.lines.filter(function (l) { return !l.ch.length; })[0];
      if (empty) {
        if (!st.same) st.active = empty.it.id;
        refresh();
        msg(!st.same && r.lines.length > 1 ? 'Wähle für ' + texName(empty.it) + ' mindestens eine Position.' : 'Wähle mindestens eine Position.', true);
        openStep(3, true);
        if (!mobile()) $('[data-fw-step="3"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (st.delivery === 'dealer' && !st.company.trim()) {
        comp.classList.add('is-error'); compErr.hidden = false;
        openStep(4, true);
        if (!mobile()) $('[data-fw-step="4"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { comp.focus({ preventScroll: true }); }, 300);
        return;
      }
      if (st.logo && st.logo.status === 'uploading') { msg('Dein Logo lädt noch hoch – einen Moment bitte.', false); return; }
      if (!r.ready) {
        if (prefill()) { msg(''); document.getElementById(data.ask).scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      var base = { 'Anlieferung': deliveryName() };
      if (st.delivery === 'dealer') base['Firmenname beim Händler'] = st.company.trim();
      if (st.dnote.trim()) base['Hinweis zur Anlieferung'] = st.dnote.trim();
      base['Logo'] = st.logo && st.logo.url ? st.logo.url : (st.logo && st.logo.status === 'local' ? st.logo.name + ' (bitte per E-Mail schicken)' : 'folgt per E-Mail');
      base._sp_parent_id = genId();
      var items = [];
      r.lines.forEach(function (l) {
        l.ch.forEach(function (p) {
          var pr = { 'Textil': texName(l.it) + ' (eigene Ware)', 'Farbe laut Vorschau': by(COL, l.it.color).name, 'Technik': TECH[techOf(p, l.it)], 'Position': p.name, 'Breite': widthOf(p, l.it) + ' cm' };
          items.push({ id: variantOf(p, l.it), quantity: l.it.qty, properties: Object.assign(pr, base) });
        });
      });
      st.busy = true;
      $$('[data-fw-add]').forEach(function (b) { b.classList.add('is-loading'); });
      msg('Wird in den Warenkorb gelegt …');
      fetch((data.root || '/').replace(/\/?$/, '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Fehler beim Hinzufügen');
          msg('Im Warenkorb: ' + r.pieces + ' Stück · <a href="' + esc(data.cartUrl || '/cart') + '">Zum Warenkorb →</a>', false, true);
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (e) {}
          if (mobile()) $('[data-fw-sum]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (err) { msg(err.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.', true); })
        .then(function () { st.busy = false; $$('[data-fw-add]').forEach(function (b) { b.classList.remove('is-loading'); }); });
    }

    /* ---------- Mobile Leiste ---------- */
    var bar = $('[data-fw-mbar]'), mbtn = $('[data-fw-mbtn]');
    if (bar && 'IntersectionObserver' in window) {
      var inView = false, sumView = false;
      var upd = function () {
        var on = inView && !sumView;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        mbtn.tabIndex = on ? 0 : -1;
        root.classList.toggle('has-mbar', mobile());
      };
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; upd(); }).observe($('.fw-grid'));
      new IntersectionObserver(function (en) { sumView = en[0].isIntersecting; upd(); }).observe($('[data-fw-sum]'));
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-fw-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
